import './utils/extendLocale';

export * from './common-extra';
export * from './components';
export * from './components-extra';
export { useSpreadSheetInstance } from './context/SpreadSheetContext';
export * from './hooks/useExpose';

export const version = '@antv/s2-vue-v2.2.0';
